// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2WQjJ","footer":"ChangeClinic_footer__15QDm"};